import React, { useContext, useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import GeneralContext from '../context/GeneralContext/GeneralContext';
import api from '../services/api';
import { Spin } from 'antd';

/**
 * Componente de rota privada
 * Verifica se o usuário está autenticado antes de permitir o acesso
 */
const PrivateRoute = () => {
  const { loggedUser, setLoggedUser, setShowLoading } = useContext(GeneralContext);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    validateSession();
  }, []);

  const validateSession = async () => {
    try {
      const token = localStorage.getItem('token');
      
      if (!token) {
        setLoading(false);
        return;
      }

      // Configura o token no axios
      await api.auth.setAuthorizationToken(token);

      // Busca os dados do usuário atual
      const response = await api.auth.currentUser();
      
      if (response.data) {
        setLoggedUser(response.data);
      }
    } catch (error) {
      console.error('Erro ao validar sessão:', error);
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100vw'
      }}>
        <Spin size="large" />
      </div>
    );
  }

  return loggedUser ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;



